import { useRef } from "react";
import Buttons from "../../../components/Buttons/Buttons";

// Shared file-select + client-side JSON validation widget, used both by the
// Add Device modal's JSON-upload mode and the per-row JSON re-upload modal.
const JsonFilePicker = ({ file, onFileSelected, error }) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const selected = e.target.files?.[0];
    if (!selected) return;

    if (!selected.name.toLowerCase().endsWith(".json")) {
      onFileSelected(null, "Please select a .json file");
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      try {
        JSON.parse(reader.result);
        onFileSelected(selected, "");
      } catch {
        onFileSelected(null, "This file isn't valid JSON");
      }
    };
    reader.onerror = () => onFileSelected(null, "Failed to read the file");
    reader.readAsText(selected);
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept=".json,application/json"
        onChange={handleFileChange}
        hidden
      />

      <div className="device-json-upload_dropzone">
        <Buttons
          text="Choose JSON File"
          variant="secondary"
          onClick={() => fileInputRef.current?.click()}
        />
        {file && <span className="device-json-upload_filename">{file.name}</span>}
      </div>

      {error && <span className="error">{error}</span>}
    </>
  );
};

export default JsonFilePicker;
